import i18next from 'i18next';

i18next.addResources('es_CL', 'CheckoutPersonalData', {
  title: 'Tus datos personales'
});

i18next.addResources('pt_PT', 'CheckoutPersonalData', {
  title: 'Os teus dados pessoais'
});
